/*globals $*/
'use strict';
/* ==========================================================================
   GLOBAL VARS
   ========================================================================== */
var regexMobile = '/Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/';
var isMobile = navigator.userAgent.match(regexMobile);

$(document).ready(function() {

    $('#xec-regal_step-two').hide();

    $('#form-contact__submit-button').on('click', function(){
        comprovaContactFormData();
    });

    //forms
    $('#para-llevar').submit(function(e) {
      validaContactFormParaLlevar($('#where_form').val());
      e.preventDefault(); // avoid to execute the actual submit of the form.
    });
    //forms
    $('#cheque-regalo').submit(function(e) {
      validaContactFormChequeRegalo($('#where_form').val());
      e.preventDefault(); // avoid to execute the actual submit of the form.
    });
});

function validaContactFormChequeRegalo(where) {
    var expr = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    var telf = /^[0-9-+]+$/;
    var ok = 1;

    var form = $('#cheque-regalo');

    var cheque = $('#cheque').val();
    var cheque_bebida = $('#cheque-bebida').val();

    var nombre = $('#nombre').val();
    var mail = $('#email').val();
    var telephone = $('#telefono').val();

    var nombre_comprador = $('#nombre_comprador').val();
    var mail_comprador = $('#email_comprador').val();
    var telephone_comprador = $('#telefono_comprador').val();

    var accept = $('#privacy_cheque').is(":checked");

    if (cheque == '') {
        $('#cheque').addClass('contact-form_input__error');
        ok = 0;
    } else {
        $('#cheque').removeClass('contact-form_input__error');
    }

    /*if (cheque_bebida == '' || cheque_bebida < 20) {
        $('#cheque-bebida').addClass('contact-form_input__error');
        $('#error_bebida').slideDown(500);
        ok = 0;
    } else {
        $('#cheque-bebida').removeClass('contact-form_input__error');
        $('#error_bebida').slideUp(500);
    }*/

    if (nombre == '') {
        $('#nombre').addClass('contact-form_input__error');
        ok = 0;
    } else {
        $('#nombre').removeClass('contact-form_input__error');
    }

    if (mail == '') {
        $('#email').addClass('contact-form_input__error');
        ok = 0;
    } else {
        $('#email').removeClass('contact-form_input__error');
        if (!expr.test(mail)) {
            $('#email').addClass('contact-form_input__error');
            ok = 0;
        } else {
            $('#email').removeClass('contact-form_input__error');
        }
    }

    if (telephone == '') {
        $('#telefono').addClass('contact-form_input__error');
        ok = 0;
    } else {
        $('#telefono').removeClass('contact-form_input__error');
        if (!telf.test(telephone)) {
            $('#telefono').addClass('contact-form_input__error');
            ok = 0;
        } else {
            $('#telefono').removeClass('contact-form_input__error');
        }
    }

    if (nombre_comprador == '') {
        $('#nombre_comprador').addClass('contact-form_input__error');
        ok = 0;
    } else {
        $('#nombre_comprador').removeClass('contact-form_input__error');
    }

    if (mail_comprador == '') {
        $('#email_comprador').addClass('contact-form_input__error');
        ok = 0;
    } else {
        $('#email_comprador').removeClass('contact-form_input__error');
        if (!expr.test(mail_comprador)) {
            $('#email_comprador').addClass('contact-form_input__error');
            ok = 0;
        } else {
            $('#email_comprador').removeClass('contact-form_input__error');
        }
    }

    if (telephone_comprador == '') {
        $('#telefono_comprador').addClass('contact-form_input__error');
        ok = 0;
    } else {
        $('#telefono_comprador').removeClass('contact-form_input__error');
        if (!telf.test(telephone_comprador)) {
            $('#telefono_comprador').addClass('contact-form_input__error');
            ok = 0;
        } else {
            $('#telefono_comprador').removeClass('contact-form_input__error');
        }
    }


    if (accept == false) {
        $('#label_privacy_cheque').addClass('contact-form_label__error');
        ok = 0;
    } else {
        $('#label_privacy_cheque').removeClass('contact-form_label__error');
    }

    if (!ok) {
        $('#enviar_ok_cheque').slideUp(100);
        $('#enviar_ko_cheque').slideUp(100);
        $('#errors_cheque').slideDown(500);
    } else {
        $('#errors_cheque').slideUp(500);
    }

    if (ok) {
        $('#btsubmit_cheque').hide();
        $('#submit_load_cheque').show();
        //form.submit();
        
        $.ajax({
            type: "POST",
            url: where + '/inc/Check/Manager/save_cheque_regalo.php',
            data: $("#cheque-regalo").serialize(), // serializes the form's elements.
            success: function(data) {
                var result = data.split('|||');
                console.log(result[0]);
                console.log(result[1]);
                console.log(result[2]);
                if (result[1] === 'true') {
                    var tpv_data = result[2].split('|');
                    console.log(tpv_data);
                    $('#tpv_version').val(tpv_data[1]);
                    $('#tpv_params').val(tpv_data[2]);
                    $('#tpv_signature').val(tpv_data[3]);

                    // window.location.replace($('#thankyou_url').val());
                    // limpiaForm('#cheque-regalo');
                    // $('#enviar_ok_cheque').slideDown(500);
                    // $('#btsubmit_cheque').show();

                    $('#xec-regal_step-one').hide();
                    $('#xec-regal_step-two').show();


                    $('#resumen-comida').html(
                        $('#cheque').val()
                    );
                    $('#resumen-bebida').html(
                        $('#cheque-bebida').val()
                    );
                    $('#resumen-nombre').html(
                        $('#nombre').val()
                    );
                    $('#resumen-email').html(
                        $('#email').val()
                    );
                    $('#resumen-telefono').html(
                        $('#telefono').val()
                    );

                    $("html, body").animate({ scrollTop: $('#xec-regal_step-two').offset().top }, 1000);

                } else {
                    $('#enviar_ko_cheque').slideDown(500);
                    $('#btsubmit_cheque').show();
                    $('#submit_load_cheque').hide();
                }
            }
        });
        
    }

    return false; // avoid to execute the actual submit of the form.

};

function validaContactFormParaLlevar(where) {
    var expr = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    var telf = /^[0-9-+]+$/;
    var ok = 1;

    $('#products_counter').hide();

    var form = $('#para-llevar');

    var nombre = $('#nombre').val();
    var apellidos = $('#apellidos').val();
    var mail = $('#email').val();
    var telephone = $('#telefono').val();
    var message = $('#mensaje').val();
    var accept = $('#privacy_llevar').is(":checked");


    var i = 0;
    var j = 0;

    $('.precio').each(function() {
        var num = parseInt( $('input[name="dishes['+i+'][num]"]').val() );
        if(num > 0){
          j = j + 1;
        }
        i = i + 1;
    });

    if(j == 0){
        ok = 0;
        $('#products_counter').show();
    }else{
        ok = 1;
        $('#products_counter').hide();
    }


    if (nombre == '') {
        $('#nombre').addClass('contact-form_input__error');
        ok = 0;
    } else {
        $('#nombre').removeClass('contact-form_input__error');
    }

    if (apellidos == '') {
        $('#apellidos').addClass('contact-form_input__error');
        ok = 0;
    } else {
        $('#apellidos').removeClass('contact-form_input__error');
    }

    if (mail == '') {
        $('#email').addClass('contact-form_input__error');
        ok = 0;
    } else {
        $('#email').removeClass('contact-form_input__error');
        if (!expr.test(mail)) {
            $('#email').addClass('contact-form_input__error');
            ok = 0;
        } else {
            $('#email').removeClass('contact-form_input__error');
        }
    }

    if (telephone == '') {
        $('#telefono').addClass('contact-form_input__error');
        ok = 0;
    } else {
        $('#telefono').removeClass('contact-form_input__error');
        if (!telf.test(telephone)) {
            $('#telefono').addClass('contact-form_input__error');
            ok = 0;
        } else {
            $('#telefono').removeClass('contact-form_input__error');
        }
    }

    if (accept == false) {
        $('#label_privacy_llevar').addClass('contact-form_label__error');
        ok = 0;
    } else {
        $('#label_privacy_llevar').removeClass('contact-form_label__error');
    }

    if (!ok) {
        $('#enviar_ok_llevar').slideUp(100);
        $('#enviar_ko_llevar').slideUp(100);
        $('#errors_llevar').slideDown(500);
    } else {
        $('#errors_llevar').slideUp(500);
    }

    if (ok) {
        $('#btsubmit_llevar').hide();
        $('#submit_load_llevar').show();
        //form.submit();
        
        $.ajax({
            type: "POST",
            url: where + '/inc/Email/Manager/send_take_away.php',
            data: $("#para-llevar").serialize(), // serializes the form's elements.
            success: function(data) {
                var result = data.split('||||');
                if (result[1] == 'true') {
                    window.location.replace($('#thankyou_url').val());
                    limpiaForm('#para-llevar');
                    $('#enviar_ok_llevar').slideDown(500);
                    $('#btsubmit_llevar').show();
                    $('#submit_load_llevar').hide();
                } else {
                    $('#enviar_ko_llevar').slideDown(500);
                    $('#btsubmit_llevar').show();
                    $('#submit_load_llevar').hide();
                }
            }
        });
        
    }

    return false; // avoid to execute the actual submit of the form.

};

function comprovaContactFormData() {

    event.preventDefault();
    $('#alert_input_errors').removeClass("visible").addClass("no_visible");
    $('#alert_input_ok').removeClass("visible").addClass("no_visible");

    var url = $('#directorio').val();

    var valid = true;
    var conditions = true;
    var formData = $('#contact_form').serialize();
    var form = $('#contact_form');
    
    var name = $('#name');
    var email = $('#email');
    var subject = $('#subject');
    var comments = $('#comments');

    if (!validateTextInput(name)) { valid = false; }
    if (!validateTextInput(subject)) { valid = false; }
    if (!validateTextInput(comments)) { valid = false; }
    if (!validateEmailInput(email)) { valid = false; }
    
    if (!$('#privacy-policy').is(':checked')) {
        valid = false;
        $('#alert_input_conditions').removeClass("no_visible").addClass("visible");
    } else {
        $('#alert_input_conditions').removeClass("visible").addClass("no_visible");
    }

    if (valid) {
        //form.submit();
        $.ajax({
            type: "POST",
            url: url + '/inc/Email/Manager/send_contact.php',
            data: formData,
            success: function(data) {
                $('#alert_input_ok').addClass("visible").removeClass("no_visible"); 
                limpiaForm(form);   
                var result = data.split('||||');
                if (result[1] == 'true') {
                    window.location.replace($('#thankyou_url').val());
                } else {
                    $('#alert_input_errors').addClass("visible").removeClass("no_visible");
                }  
            },
            async: false
        });
    } else {
        $('#alert_input_errors').addClass("visible").removeClass("no_visible");
        return false;
    }
}

function validateTextInput(input) {
    var value = input.val();
    if (value) {
        input.removeClass("invalid").addClass("valid");
        return true;
    } else {
        input.removeClass("valid").addClass("invalid");
        return false;
    }
}

function validateSelectInput(input) {
    var value = input.val();
    if (value != 'no') {
        input.removeClass("invalid").addClass("valid");
        return true;
    } else {
        input.removeClass("valid").addClass("invalid");
        return false;
    }
}

function validateNumberInput(input) {
    var value = input.val();
    if (value) {
        if ($.isNumeric(value) && value > 0) {
            input.removeClass("invalid").addClass("valid");
            return true;
        } else {
            input.removeClass("valid").addClass("invalid");
            return false;
        }
    } else {
        input.removeClass("valid").addClass("invalid");
        return false;
    }
}

function validateEmailInput(input) {
    var re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    var value = input.val();

    var is_email = re.test(input.val());

    if (value) {
        if (is_email) {
            input.removeClass("invalid").addClass("valid");
            return true;
        } else {
            input.removeClass("valid").addClass("invalid");
            return false;
        }
    } else {
        input.removeClass("valid").addClass("invalid");
        return false;
    }
}

function validatePhoneInput(input) {
    var filter = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;
    var value = input.val();
    var value = input.val();

    var is_phone = filter.test(input.val());

    if (value) {
        if (is_phone) {
            input.removeClass("invalid").addClass("valid");
            return true;
        } else {
            input.removeClass("valid").addClass("invalid");
            return false;
        }
    } else {
        input.removeClass("valid").addClass("invalid");
        return false;
    }
}

/*------- /VALIDACIO DEL FORMULARI --------*/
function limpiaForm(miForm) {
    // recorremos todos los campos que tiene el formulario
    $(':input', miForm).each(function() {
        var type = this.type;
        var tag = this.tagName.toLowerCase();
        //limpiamos los valores de los campos…
        if (type == 'text' || type == 'password' || tag == 'textarea' || type == 'email')
            this.value = "";
        // excepto de los checkboxes y radios, le quitamos el checked
        // pero su valor no debe ser cambiado
        else if (type == 'checkbox' || type == 'radio')
            this.checked = false;
        // los selects le ponesmos el indice a -
        else if (tag == 'select')
            this.selectedIndex = -1;
    });
}